import styled, { css } from "styled-components";

export const BannerContainer = styled.div`
  position: relative;
  padding-top: 40px;
  min-height: 300px;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: cover;

  ${({ background }) =>
    background &&
    css`
      background-image: url(${background.desktop});
    `}

  @media only screen and (max-width: 768px) {
    ${({ background }) =>
    background &&
    css`
        background-image: url(${background.mobile});
      `}
  }
`;

export const BannerTitleBackground = styled.div`
  position: absolute;
  top: 25px;
  width: 70%;
  left: 15%;
  opacity: 40%;
  z-index: 0;
  @media only screen and (max-width: 768px) {
    width: 90%;
    left: 5%;
    top: 120px;
  }
`;

export const TitleContainer = styled.div`
  position: relative;
  top: -1.5rem;
`;
export const SubtitleContainer = styled.div`
  opacity: .7;
  ${({ width }) => css`
    width: ${width};
    position: absolute;
    top: 3rem;
    left: 50%;
    transform: translateX(-50%);
  `};

  @media only screen and (max-width: 768px) {
    width: 90%;
    top: 75px;
  }
`;
